import { api } from "./api";

// Calls the backend AI Clip Scanner. Returns { engine, results:[{ts,sec,label,conf,green,contested,highlight}], note }.
export async function scanClip({ url = "", prompt = "", player = "" }) {
  const { data } = await api.post("/clip-scan", { url, prompt, player });
  return data;
}
